import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
interface props {
  showPopup: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PopupFull',
  props: {
    showPopup: { default: false }
  },
  emits: ["closePopup", "submitPopup"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const propsData = __props;

const handleOk = () => {
  emits('submitPopup', true)
};

const handleCancel = () => {
  emits('closePopup', false)
};

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: _ctx.showPopup,
      onCancel: handleCancel,
      footer: false,
      "wrap-class-name": "full-modal",
      width: "100%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ]),
      _: 3
    }, 8, ["open"])
  ]))
}
}

})